export const presets = {
  dark: {
    bg: "bg-gray-950",
    bgGrad: "bg-gradient-to-b from-gray-950 via-gray-900 to-gray-950",
    card: "bg-gray-900/60 border border-white/5",
    soft: "bg-white/5",
    softBorder: "border-white/10",
    border: "border-white/5",
    text: "text-white",
    subtext: "text-gray-400",
    subtextStrong: "text-gray-300",
    softText: "text-gray-300",
    neutralBtn: "bg-white/5 text-white",
    inputBg: "bg-gray-800",
    inputText: "text-white",
    inputBorder: "border-white/10",
    inputAltBg: "bg-gray-900/60",
    inputAltText: "text-white",
    inputAltBorder: "border-white/10",
    track: "bg-white/10",
    ringInner: "bg-gray-900/80",
    menuText: "text-white"
  },
  white: {
    bg: "bg-white",
    bgGrad: "bg-gradient-to-b from-white via-gray-50 to-white",
    card: "bg-white border border-gray-200",
    soft: "bg-gray-100",
    softBorder: "border-gray-200",
    border: "border-gray-200",
    text: "text-gray-900",
    subtext: "text-gray-600",
    subtextStrong: "text-gray-700",
    softText: "text-gray-700",
    neutralBtn: "bg-gray-100 text-gray-900",
    inputBg: "bg-gray-100",
    inputText: "text-gray-900",
    inputBorder: "border-gray-300",
    inputAltBg: "bg-white",
    inputAltText: "text-gray-900",
    inputAltBorder: "border-gray-300",
    track: "bg-gray-200",
    ringInner: "bg-white"
  },
  primary: {
    bg: "bg-gradient-to-b from-pink-50 via-white to-pink-50",
    bgGrad: "bg-gradient-to-b from-pink-50 via-white to-pink-50",
    card: "bg-white border border-pink-100",
    soft: "bg-pink-50",
    softBorder: "border-pink-200",
    border: "border-pink-200",
    text: "text-gray-900",
    subtext: "text-pink-700",
    subtextStrong: "text-gray-700",
    softText: "text-pink-800",
    neutralBtn: "bg-pink-50 text-gray-900",
    inputBg: "bg-pink-50",
    inputText: "text-gray-900",
    inputBorder: "border-pink-200",
    inputAltBg: "bg-white",
    inputAltText: "text-gray-900",
    inputAltBorder: "border-pink-200",
    track: "bg-pink-200",
    ringInner: "bg-white"
  },
  secondary: {
    bg: "bg-gradient-to-b from-blue-50 via-white to-blue-50",
    bgGrad: "bg-gradient-to-b from-blue-50 via-white to-blue-50",
    card: "bg-white border border-blue-100",
    soft: "bg-blue-50",
    softBorder: "border-blue-200",
    border: "border-blue-200",
    text: "text-gray-900",
    subtext: "text-blue-700",
    subtextStrong: "text-gray-700",
    softText: "text-blue-800",
    neutralBtn: "bg-blue-50 text-gray-900",
    inputBg: "bg-blue-50",
    inputText: "text-gray-900",
    inputBorder: "border-blue-200",
    inputAltBg: "bg-white",
    inputAltText: "text-gray-900",
    inputAltBorder: "border-blue-200",
    track: "bg-blue-200",
    ringInner: "bg-white"
  }
}
